import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const AccountSearchUserLimit = (props) => {
    const { data, translate } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    if (data.length < 12) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate('notifications.accounts.create.search_user_limit', { count: data.length }) }
        </ErrorMessageField>
    );
};

AccountSearchUserLimit.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(AccountSearchUserLimit);



// WEBPACK FOOTER //
// ./src/components/notifications/AccountSearchUserLimit.js